<script setup lang="ts">
export type Props = {
  data: string
}

const { public: config } = useRuntimeConfig()
const props = defineProps<Props>()

const documents = computed(() => {
  const docs = JSON.parse(props.data || '[]')
  return docs.map((doc: any) => {
    return {
      label: doc.title,
      link: (config.xcdnUrl.replace(/\/+$/, '') + doc.filePath),
    }
  })
})
</script>

<template>
  <div
    v-if="documents.length"
    class="file-downloads--list"
  >
    <ul>
      <li
        v-for="document in documents"
        :key="document"
      >
        <AppLink
          :to="document.link"
          class="file-downloads--link"
        >
          <icon
            name="icon:download"
            class="icon icon--download"
            aria-hidden="true"
          />
          <span>
            {{ document.label }}
          </span>
        </AppLink>
      </li>
    </ul>
  </div>
</template>

<style>
 @import url('~layers/app/components/Product/Downloads.css');
</style>
